import { Injectable } from '@angular/core';
// @ts-ignore
import isPlainObject from 'lodash/isPlainObject';
import { CookieKey } from '../shared-ts/cookies/cookie-keys.const';
import { getCookie, setCookie, removeCookie } from '../shared-ts/cookies/cookies';

const COOKIE: CookieKey = CookieKey.DASHBOARD_STORAGE;

@Injectable({ providedIn: 'root' })
export class SessionStorage {
  private _data;

  constructor() {
    this._data = this._getCookie();
  }

  public getKey(key: string) {
    return this._data[key];
  }

  public setKey(key: string, value: any) {
    this._data[key] = value;
    this._setCookie(this._data);
  }

  public removeCookie(): void {
    removeCookie(COOKIE);
  }

  private _getCookie() {
    let data;
    try {
      data = JSON.parse(getCookie(COOKIE));
      data = isPlainObject(data) ? data : {};
    } catch (e) {
      data = {};
      this._setCookie(data);
    }
    return data;
  }

  private _setCookie(data: any) {
    setCookie(COOKIE, data);
  }

}
